import qc from "keys/queryClient";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "store";
import { getNetoAudioFileFetch } from "store/middlewares/assessment.crud";
import { markingWordsHooks } from "..";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";



const useGetAudioNeto = () => {
    const dispatch = useDispatch()

    const params = useParams()

    let assessmentID = params.assessmentID

    const isTraining = markingWordsHooks.useIsTraining()

    useQuery({
        queryKey: [qc.netoAudioFile, assessmentID],
        queryFn: async () => {
            try {
                const { data } = await getNetoAudioFileFetch(assessmentID, isTraining);

                if (data) {
                    const audioURL = URL.createObjectURL(new Blob([data]));
                    dispatch(actions.updateAssessment({ neto_audio_file: audioURL }));
                }

                return null;
            } catch (error) {
                console.error("Error fetching audio file:", error);
                dispatch(actions.updateAssessment({ neto_audio_file: null }));
            }
        },
        retry: 0
    })

}

export default useGetAudioNeto